import QuickStartGuidePage from "../../../../src/mdx/api/quick-start-guide";
import * as React from 'react';
export default {
  QuickStartGuidePage,
  React
};